import { render, staticRenderFns } from "./CouponLayout.vue?vue&type=template&id=81136f52&scoped=true"
import script from "./CouponLayout.vue?vue&type=script&lang=js"
export * from "./CouponLayout.vue?vue&type=script&lang=js"
import style0 from "./CouponLayout.vue?vue&type=style&index=0&id=81136f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81136f52",
  null
  
)

export default component.exports